import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  del,
  formDataPost,
  formDataPut,
  get,
  patch,
  post,
  put,
} from "helpers/api_helper"
import {
  ADD_VEHICLE,
  DELETE_VEHICLE,
  GET_ALL_VEHICLES,
  GET_VEHICLE_DETAILS,
  UPDATE_VEHICLE,
  UPDATE_VEHICLE_STATUS,
} from "helpers/url_helper"

export const getAllVehicles = createAsyncThunk(
  GET_ALL_VEHICLES,
  async payload => {
    const response = await post(GET_ALL_VEHICLES, payload)
    return response
  }
)

export const addVehicle = createAsyncThunk(ADD_VEHICLE, async payload => {
  const response = await formDataPost(ADD_VEHICLE, payload)
  return response
})

export const getVehicleDetails = createAsyncThunk(
  GET_VEHICLE_DETAILS,
  async payload => {
    const response = await post(GET_VEHICLE_DETAILS, payload)
    return response
  }
)

export const updateVehicle = createAsyncThunk(UPDATE_VEHICLE, async payload => {
  const response = await formDataPut(UPDATE_VEHICLE, payload)
  return response
})

export const updateVehicleStatus = createAsyncThunk(
  UPDATE_VEHICLE_STATUS,
  async payload => {
    const response = await patch(UPDATE_VEHICLE_STATUS, payload)
    return response
  }
)

export const deleteVehicle = createAsyncThunk(DELETE_VEHICLE, async payload => {
  const response = await del(DELETE_VEHICLE, payload)
  return response
})
